import React from 'react'
import { Icon } from '@scalis/components/src'
import { cn } from '@scalis/utils'
import { Button, ButtonKind, ButtonSize } from '../button'
import { FileUploaderProps } from './file-uploader.types'

export const FileUploader = ({ onFileSelect, className }: FileUploaderProps) => {
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const files = e.dataTransfer.files
    if (files && files[0]) {
      onFileSelect?.(files[0])
    }
  }

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files
    if (files && files[0]) {
      onFileSelect?.(files[0])
    }
  }

  return (
    <div className={cn('bg-neutral-00 p-4 rounded-xl', className)}>
      <div
        className={cn(
          'border-neutral-10 border border-dashed mx-auto flex gap-4 cursor-pointer flex-col items-center justify-center rounded-xl px-4 py-8 text-center',
        )}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => document.getElementById('file-input')?.click()}
      >
        <Icon className='fa-regular fa-cloud-upload fa-2x text-icon-neutral-10' />
        <div className='font-inter text-center text-sm font-normal leading-6 tracking-[-0.6px] text-neutral-secondary'>
          <span className='body-small-basic'>Drag and drop your files here</span>
        </div>
        <input
          id='file-input'
          type='file'
          className='hidden'
          accept='image/*'
          data-testid='file-input'
          onChange={handleFileInput}
        />
        <Button
          text='Browse Files'
          endAdornment='fa-regular fa-upload'
          kind={ButtonKind.tertiary}
          size={ButtonSize.medium}
        />
      </div>
    </div>
  )
}
